import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import Sidebar from './sidebar';
import React, { useState, useEffect } from 'react';
import api from "../api";

function Settlement() {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate();
    const location = useLocation();

    const token = localStorage.getItem("access_token");

    const [withdrawals, setWithdrawals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        fetchWithdrawals();
    }, []);

    const fetchWithdrawals = async () => {
        try {
            const response = await api.get(`${baseUrl}/vendor/withdrawals/`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setWithdrawals(response.data.withdrawals);
        } catch (err) {
            setError("Failed to fetch withdrawals. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const getVendorCurrency = () => {
        return localStorage.getItem("VendorCurrency");
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        const day = date.getDate();
        const time = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).toLowerCase();

        return `${month} ${day}, ${time.replace(':', '.')}`;
    }

    const filteredResults = withdrawals.filter((withdrawal) => {
        const search = searchTerm.toLowerCase();
        return (
            withdrawal.reference.toLowerCase().includes(search) ||
            withdrawal.status.toLowerCase().includes(search)
        );
    });

    return (
        <>
            <Helmet>
                <title>Settlement Overview</title>
                <meta name="description" content={`Settlement Overview`} />
            </Helmet>

            <section className="container mtopcon dashb">
                <div className="row">

                    <div className="col-12 col-lg-2 dash-min mb-3">
                        <div className="nav-left-sidebar sidebar-dark pc">
                            <div className="menu-list">
                                <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav">
                                        <span className="navbar-toggler-icon"></span>
                                    </button>
                                    <div className="collapse navbar-collapse" id="navbarNav">
                                        <Sidebar />
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-10 dash-max">
                        <div className="row mb-4 ph-header-con">
                            <h6 className="pageheader-title mb-0">Settlement History</h6>
                            <p className="grey-text lh0 font8">All pending settlements are paid to your account within 48hours.</p>
                        </div>

                        <div className="row mb-3">
                            <div className="col-12 orderscontainer">
                                <hr className="hddsktp0" />

                                <div className="mb-4">
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <input
                                                className="filter2 border me-2 w-100"
                                                type="search"
                                                placeholder="Search Transactions"
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {filteredResults.length === 0 ? (
                                        <p>No settlements yet — your payouts will appear here once you start receiving orders.</p>
                                    ) : (
                                        filteredResults.map((item, index) => (
                                            <div className="row ord-bg bg-white p-2 hvr bx-shadow" key={item.id}>
                                                <div className="w-auto me-3 rownumsn p-0">
                                                    <div className="pt-2 pl-2">{index + 1}</div>
                                                </div>

                                                <div className="col-10 col-lg-11 pl-0 pr-0">
                                                    <div className="row">
                                                        <div className="col-7 col-lg-3 ord-sz">#W{item.id}</div>

                                                        <div className="col-5 col-lg-3 ord-sz text-primary">
                                                            <span
                                                                className={`badge rounded-pill 
                                                                ${item.status === 'success'
                                                                    ? 'bg-success'
                                                                    : item.status === 'failed'
                                                                        ? 'bg-danger'
                                                                        : 'bg-warning'
                                                                }`}
                                                            >
                                                                {item.status}
                                                            </span>
                                                        </div>

                                                        <div className="col-7 col-lg-4 ord-sz grey-text">
                                                            {getVendorCurrency()} {item.amount}
                                                        </div>

                                                        <div className="col-5 col-lg-2 ord-sz grey-text">
                                                            {formatDate(item.created_at)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </>
    );
}

export default Settlement;
